import { useEffect, useRef, useState } from 'react';
import ImagenBannerDAROVI from '../../assets/images/IMMSA.jpg';
import './DAROVI.css';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Telefono from '../../assets/images/Telefono.png';
import Ubi from '../../assets/images/Ubi.png';
import Email34 from '../../assets/images/Correo.png';
import RedesFondo from '../../assets/images/Red-Neuronal.png';
import checkAnim from '../../assets/images/check.gif';

function DAROVI() {

    
  return (
    <>
    <div className="infra-banner-DAROVI">
  <img src={ImagenBannerDAROVI} alt="DAROVI" className="banner-img-DAROVI" />
    <h1 className="banner-texto-DAROVI">FARMACOS DAROVI</h1>
</div>
<div className="fondo-blanco-DAROVI">
<div className="contenedor-DAROVI">
  <div className="columna-izquierda-DAROVI">
     <h1>SECTOR:</h1>
    <p>FARMACOS</p>
    <h1>PAIS:</h1>
    <p>MÉXICO</p>
    <h1>EMPRESA:</h1>
     <p> Fármacos Darovi es una empresa con sólida presencia en el sector salud, reconocida por su capacidad logística, cobertura nacional y enfoque multisectorial. Con más de dos décadas de experiencia, se ha consolidado como un proveedor estratégico para instituciones públicas y privadas, ofreciendo soluciones integrales en medicamentos genéricos y de patente, material de curación, equipo médico y productos hospitalarios.<br>
     </br>
     <br></br>
Su infraestructura permite atender desde farmacias locales hasta grandes hospitales, clínicas, laboratorios y entidades gubernamentales, lo que la posiciona como un actor clave en la cadena de suministro farmacéutica. Además, su modelo de negocio abarca distintos segmentos del sector salud, lo que le otorga versatilidad y capacidad de adaptación ante las demandas del mercado.
    </p>
    <div className="boton-reto-DAROVI">
      <a href="https://www.immsa.mx/" className="btn-reto-DAROVI">Ver más información</a>
    </div>
  </div>

  <div className="columna-derecha-DAROVI">
    <h2>RETO</h2>
    <p>Pendiente.</p>

    <h2>IMPLANTACIÓN DE LIBRA ERP</h2>
    <p>Pendiente.</p>

    <h2>RESEÑA</h2>
    <p>Pendiente.</p>
  </div>
</div>
</div>

{/* Contenedor principal  de pie de página con contacto*/}

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-ite">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        <li><a href="/">• IAutomatiza CFDI</a></li>
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Sistemas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        <li><a href="/CasosExito">Ver Mas Casos de Éxito</a></li>
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>

</>
  );
}

export default DAROVI;